import {
  getEntrepreneursCubeDimensionValues
} from "./get-entrepreneurs-cube-dimension-values";

export const getEntrepreneursCareers = () => {
  return getEntrepreneursCubeDimensionValues("teamMemberCareer");
};
